import { c as _c } from "react/compiler-runtime";
import { extractJsonSchemaSteps } from "forms/helpers/stepsHelpers";
import useParseSchema from "forms/hooks/useParseSchema";
import { useIntl } from "react-intl";
import type { IJsonSchema, IJsonSchemaClauses, IJsonSchemaConsents, IProperty } from "types/jsonSchema";
import { predefinedFields } from "types/predefinedFields";
import { z } from "zod";
export const usePrepareSchema = t0 => {
  const $ = _c(11);
  const {
    jsonSchema,
    isTwoStepForm,
    repeatEmail
  } = t0;
  const {
    formatMessage
  } = useIntl();
  const {
    parseSchema
  } = useParseSchema();
  let defaultSchema;
  let t1;
  if ($[0] !== formatMessage || $[1] !== isTwoStepForm || $[2] !== jsonSchema || $[3] !== parseSchema || $[4] !== repeatEmail) {
    const jsonSteps = extractJsonSchemaSteps(jsonSchema);
    let t2;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = z.looseObject({});
      $[7] = t2;
    } else {
      t2 = $[7];
    }
    defaultSchema = t2;
    const prepareFirstStepToParse = _temp;
    let t3;
    if ($[8] !== jsonSchema || $[9] !== repeatEmail) {
      t3 = () => {
        const {
          firstStep,
          secondStep
        } = extractJsonSchemaSteps(jsonSchema);
        const firstStepData = prepareFirstStepToParse(firstStep, repeatEmail);
        return {
          ...firstStepData,
          ...secondStep
        };
      };
      $[8] = jsonSchema;
      $[9] = repeatEmail;
      $[10] = t3;
    } else {
      t3 = $[10];
    }
    const prepareTwoStepsToParse = t3;
    const requiredFields = [...(jsonSchema.required || [])];
    if (repeatEmail) {
      requiredFields.push(predefinedFields.repeatEmail);
    }
    const parsedSchema = parseSchema(isTwoStepForm ? prepareFirstStepToParse(jsonSteps.firstStep, repeatEmail) : prepareTwoStepsToParse(), requiredFields);
    t1 = parsedSchema?.superRefine((fields, ctx) => {
      if (repeatEmail && fields.email !== fields.repeatEmail) {
        ctx.issues.push({
          code: "custom",
          message: formatMessage({
            id: "emailsDoNotMatch"
          }),
          path: ["repeatEmail"],
          input: fields.email
        });
      }
    });
    $[0] = formatMessage;
    $[1] = isTwoStepForm;
    $[2] = jsonSchema;
    $[3] = parseSchema;
    $[4] = repeatEmail;
    $[5] = defaultSchema;
    $[6] = t1;
  } else {
    defaultSchema = $[5];
    t1 = $[6];
  }
  const schema = t1;
  return schema ?? defaultSchema;
};
function _temp(firstStepJson, shouldRepeatEmail) {
  const data = {};
  [predefinedFields.firstName, predefinedFields.lastName, predefinedFields.email, predefinedFields.phone, predefinedFields.cvFiles, predefinedFields.workLocation, predefinedFields.workLocations].forEach(key => {
    if (firstStepJson[key]) {
      Object.assign(data, {
        [key]: firstStepJson[key]
      });
    }
  });
  if (shouldRepeatEmail) {
    Object.assign(data, {
      repeatEmail: {
        type: "string",
        minLength: 1
      }
    });
  }
  return data;
}